import { Button, Card, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';

import React from 'react';

import classes from './Login.module.less';

import useAuth from 'hooks/useAuth';
import useLoading from 'hooks/useLoading';

type LoginForm = { name: string; password: string };

const Login = () => {
	const auth = useAuth();
	const loading = useLoading();

	const [form] = useForm<LoginForm>();

	const onSubmit = async () => {
		loading.enable();

		await auth.login(form.getFieldValue('name'), form.getFieldValue('password'));
		loading.disable();
	};

	return (
		<div className={classes.container}>
			<Card title="Авторизация" bordered={false} className={classes.card}>
				<Form form={form} layout="vertical" name="basic" onFinish={onSubmit}>
					<Form.Item label="Имя" name="name" rules={[{ required: true }]}>
						<Input />
					</Form.Item>

					<Form.Item label="Пароль" name="password" rules={[{ required: true }]}>
						<Input.Password />
					</Form.Item>

					<Button type="primary" htmlType="submit">
						Войти
					</Button>
				</Form>
			</Card>
		</div>
	);
};

export default Login;
